import styled from "styled-components";

export const Row = styled.div`
  display: flex;
  width: 100%;
  justify-items: center;
`

export const RowBetween = styled(Row)`
  justify-content: space-between;
`
